// extracted by mini-css-extract-plugin
export default {"bio":"T-","about":"U-","title":"V-","text":"W-","fun_facts":"X-","fun":"Y-","icon":"Z-","bio_header":"a0"};
    if(module.hot) {
      // 1715276859864
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  